(() => {
  if (window.orbitGalleryImageLoading) return;
  window.orbitGalleryImageLoading = true;

  function loadSlide(gallery, index) {
    const slides = gallery.querySelectorAll('.fresh-card__slide');
    const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
    const image = slide?.querySelector('img[data-gallery-src]');
    if (!image) return;
    image.loading = 'eager';
    if (image.dataset.gallerySrcset) image.srcset = image.dataset.gallerySrcset;
    image.src = image.dataset.gallerySrc;
    delete image.dataset.gallerySrc;
    delete image.dataset.gallerySrcset;
  }

  function slideIndex(gallery) {
    return Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
  }

  // Capture runs before the existing arrow handler scrolls the gallery.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-gallery-next], [data-gallery-prev]');
    const gallery = button?.closest('.fresh-card__image')?.querySelector('[data-fresh-gallery]');
    if (gallery) loadSlide(gallery, slideIndex(gallery) + (button.hasAttribute('data-gallery-next') ? 1 : -1));
  }, true);

  // Native scrolling covers touch swipes and keyboard navigation, including
  // cards inserted later by collection filters or pagination.
  document.addEventListener('scroll', (event) => {
    const gallery = event.target;
    if (!(gallery instanceof Element) || !gallery.matches('[data-fresh-gallery]')) return;
    const position = gallery.scrollLeft / Math.max(gallery.clientWidth, 1);
    loadSlide(gallery, Math.floor(position));
    loadSlide(gallery, Math.ceil(position));
  }, true);
})();